// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reseller-agent-dashboard {
  margin-bottom: 48px;
  padding: 0 20px;
  background: linear-gradient(to bottom, #efefef 49%, #fff 20%);
}
.optimum-plan {
  padding-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 0;
  padding-top: 46px;
}
.customer-info {
  padding-bottom: 12px;
  padding-top: 30px;
}
.optimum-plan h1,
.customer-info h1 {
  font-size: 36px;
  font-weight: 500;
  line-height: 50px;
  text-align: left;
  align-self: flex-start;
  padding-left: 13%;
}
.fields {
  margin-top: 22px;
}
.fields.solid-border {
  border: 1px solid var(--border) !important;
  position: relative;
  min-height: auto !important;
}
.selected-plan {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
  padding-bottom: 24px;
  width: 100%;
}
.input {
  font-family: "Plus Jakarta Sans", sans-serif !important;
}
.fields div:nth-of-type(9) .input {
  height: 74px;
  border-radius: 10px !important;
  justify-content: flex-start;
  padding: 11px 15px;
}
.fields div:nth-of-type(7) {
  position: relative;
}
/* .customer-info .fields div:nth-of-type(7) {
  width: 55% !important;
} */
.fields {
  box-shadow: 0px 29px 63px 0px #9e9e9e1a;
  row-gap: 16px;
  display: flex;
  flex-wrap: wrap;
  column-gap: 3%;
  align-items: flex-end;
  border: 1px dashed #bdbdbd;
  border-radius: 20px;
  background: var(--white);
  padding: 30px 30px 40px;
  width: 71%;
  position: relative;
  min-height: 140px;
  align-items: baseline;
}

.optimum-plan .error {
  align-self: flex-start;
  padding-left: 13%;
  font-size: 14px;
  font-weight: 500;
  line-height: 17.64px;
  text-align: left;
}
.customer-info .fields {
  max-width: 1377px;
  margin-left: 13%;
  margin-right: 13%;
  display: flex;
  flex-wrap: wrap;
  column-gap: 50px;
  row-gap: 30px;
  margin-top: 20px;
}
.fields p,
.reseller-agent-dashboard .checkbox-container p {
  font-size: 14px;
  font-weight: 500;
  line-height: 17.64px;
  text-align: left;
}
.reseller-agent-dashboard .checkbox-container p {
  font-size: 13px;
}
.reseller-agent-dashboard .checkbox-container {
  display: flex;
  flex-direction: column;
  padding-left: 13%;
  margin-top: 20px;
}
.reseller-agent-dashboard .checkbox-container .checkbox {
  display: flex;
  gap: 10px;
}
.reseller-agent-dashboard .checkbox-container .checkbox input {
  width: 16px;
  height: 16px;
  margin: 0;
}
.device-available-note {
  padding-left: 13%;
  margin-top: 16px;
  margin-bottom: 38px;
  font-size: 12px;
  font-style: italic;
  font-weight: 300;
  line-height: 15.12px;
}
.device-available-note span {
  color: var(--validationError);
}
.reseller-agent-dashboard .btn {
  margin-left: 13%;
  width: 186px;
  height: 52px;
  border-radius: 100px;
  background: var(--orange);
  outline: none;
  border: none;
  font-size: 16px;
  font-weight: 700;
  line-height: 20.16px;
  color: var(--white);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}
.btn.add-plan {
  margin: 0;
  width: 159px;
  left: 50%;
  bottom: -50px;
  align-self: end;
}

.field-container .disable {
  background: var(--diabledBtn);
}
textarea {
  font-family: Plus Jakarta Sans;
  font-size: 16px;
  font-weight: 400;
  line-height: 17.64px;
  text-align: left;
}
.remove-plan {
  border: none;
  outline: none;
  background: var(--white);
}
.edit-plan {
  border: none;
  outline: none;
  background: var(--white);
}
.plan-actions {
  position: absolute;
  bottom: 26px;
  right: 12px;
}
.plan-actions-edit {
  display: none;
}
.plan-edit-actions {
  position: absolute !important;
  bottom: 39px;
  right: 12px;
}
.cancel-btn {
  width: 125px;
  height: 44px;
  border-radius: 40px;
  color: #052456;
  background-color: #fff;
  border: 1px solid #191919;
  font-size: 15px;
  font-weight: 600;
}
.apply-btn {
  width: 125px;
  height: 44px;
  border-radius: 40px;
  background-color: #f15e22;
  color: #fff;
  border: none;
  font-size: 15px;
  font-weight: 600;
  margin-left: 20px;
}
.radio-group {
  display: flex;
  gap: 20px;
  margin-bottom: 16px;
}

.optimum-plan-container {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
}

.plan-selection-box {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  border: 1px dashed #ccc;
  border-radius: 8px;
}

.configure-container {
  position: static !important;
  width: 25% !important;
}

.toggle-container {
  display: flex;
  flex-direction: row;
  width: 400px;
  gap: 60px;
  position: relative;
}

.toggle-switch {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 10px;
}

.toggle-input-container {
  margin-top: 15px;
}

.configure-add-plan {
  position: absolute;
  left: 59vw !important;
  bottom: 47px !important;
}

.configure-mobile-container {
  gap: 15px;
}

.plans-error-message {
  position: absolute;
  bottom: -20px;
  right: 120px;
}

.edit-error {
  width: 75%;
}

.configure-radio-container {
  display: flex;
  flex-direction: row;
  margin-top: 15px;
}

.configure-label {
  font-size: 14px;
  font-weight: 500;
}

.configure-input {
  min-width: 200px;
  height: 40px;
  border: solid 1px #c5c5c7;
  background: #fff;
  border-radius: 100px;
  padding-left: 15px;
  color: #000;
}

.configure-imei-input {
  margin-top: 15px;
  color: #000;
}

.configure-radio-btn {
  margin-top: 10px;
  margin-right: 10px;
}

.find-imei {
  text-decoration: underline;
  cursor: pointer;
  color: #757575;
  padding: 10px 0 0 15px;
}

.find-imei-menu {
  position: absolute;
  width: 250px;
  background-color: #fff;
  padding: 15px;
  border: 1px #bdbdbd solid;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 2;
}

.find-imei-menu-items {
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* justify-content: left; */
}

.find-imei-content {
  font-size: 14px;
  font-weight: 400 !important;
  align-content: center;
}
.find-imei-info {
  font-style: italic;
  font-size: 13px !important;
  color: #757575;
}
.check-compatibility {
  position: absolute;
  width: 260px;
  left: -20px;
  top: 28px;
}
.error-message {
  color: red;
  font-size: 12px;
}
.radio-container-label {
  min-width: 125px;
}
.check-compatibility-contianer {
  position: relative;
}
.imei-container {
  position: relative;
}
/* Hide arrows for Chrome, Safari, Edge, and Opera */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Hide arrows for Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

@media screen and (max-width: 991px) {
  .optimum-plan .fields {
    /* margin-left: 7%;
    margin-right: 7%; */
    width: 80%;
  }
}

@media screen and (max-width: 767px) {
}
`, "",{"version":3,"sources":["webpack://./src/pages/resellerAgentDashboard/resellerAgentDashboard.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,eAAe;EACf,6DAA6D;AAC/D;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,uDAAuD;AACzD;AACA;EACE,YAAY;EACZ,8BAA8B;EAC9B,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;;GAEG;AACH;EACE,uCAAuC;EACvC,aAAa;EACb,aAAa;EACb,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,0BAA0B;EAC1B,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,SAAS;EACT,YAAY;EACZ,SAAS;EACT,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,aAAa;EACb,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;AACX;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA,oDAAoD;AACpD;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE;uBACmB;IACnB,UAAU;EACZ;AACF;;AAEA;AACA","sourcesContent":[".reseller-agent-dashboard {\n  margin-bottom: 48px;\n  padding: 0 20px;\n  background: linear-gradient(to bottom, #efefef 49%, #fff 20%);\n}\n.optimum-plan {\n  padding-bottom: 30px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-left: 0;\n  padding-top: 46px;\n}\n.customer-info {\n  padding-bottom: 12px;\n  padding-top: 30px;\n}\n.optimum-plan h1,\n.customer-info h1 {\n  font-size: 36px;\n  font-weight: 500;\n  line-height: 50px;\n  text-align: left;\n  align-self: flex-start;\n  padding-left: 13%;\n}\n.fields {\n  margin-top: 22px;\n}\n.fields.solid-border {\n  border: 1px solid var(--border) !important;\n  position: relative;\n  min-height: auto !important;\n}\n.selected-plan {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 40px;\n  padding-bottom: 24px;\n  width: 100%;\n}\n.input {\n  font-family: \"Plus Jakarta Sans\", sans-serif !important;\n}\n.fields div:nth-of-type(9) .input {\n  height: 74px;\n  border-radius: 10px !important;\n  justify-content: flex-start;\n  padding: 11px 15px;\n}\n.fields div:nth-of-type(7) {\n  position: relative;\n}\n/* .customer-info .fields div:nth-of-type(7) {\n  width: 55% !important;\n} */\n.fields {\n  box-shadow: 0px 29px 63px 0px #9e9e9e1a;\n  row-gap: 16px;\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: 3%;\n  align-items: flex-end;\n  border: 1px dashed #bdbdbd;\n  border-radius: 20px;\n  background: var(--white);\n  padding: 30px 30px 40px;\n  width: 71%;\n  position: relative;\n  min-height: 140px;\n  align-items: baseline;\n}\n\n.optimum-plan .error {\n  align-self: flex-start;\n  padding-left: 13%;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17.64px;\n  text-align: left;\n}\n.customer-info .fields {\n  max-width: 1377px;\n  margin-left: 13%;\n  margin-right: 13%;\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: 50px;\n  row-gap: 30px;\n  margin-top: 20px;\n}\n.fields p,\n.reseller-agent-dashboard .checkbox-container p {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17.64px;\n  text-align: left;\n}\n.reseller-agent-dashboard .checkbox-container p {\n  font-size: 13px;\n}\n.reseller-agent-dashboard .checkbox-container {\n  display: flex;\n  flex-direction: column;\n  padding-left: 13%;\n  margin-top: 20px;\n}\n.reseller-agent-dashboard .checkbox-container .checkbox {\n  display: flex;\n  gap: 10px;\n}\n.reseller-agent-dashboard .checkbox-container .checkbox input {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n}\n.device-available-note {\n  padding-left: 13%;\n  margin-top: 16px;\n  margin-bottom: 38px;\n  font-size: 12px;\n  font-style: italic;\n  font-weight: 300;\n  line-height: 15.12px;\n}\n.device-available-note span {\n  color: var(--validationError);\n}\n.reseller-agent-dashboard .btn {\n  margin-left: 13%;\n  width: 186px;\n  height: 52px;\n  border-radius: 100px;\n  background: var(--orange);\n  outline: none;\n  border: none;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 20.16px;\n  color: var(--white);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n}\n.btn.add-plan {\n  margin: 0;\n  width: 159px;\n  left: 50%;\n  bottom: -50px;\n  align-self: end;\n}\n\n.field-container .disable {\n  background: var(--diabledBtn);\n}\ntextarea {\n  font-family: Plus Jakarta Sans;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 17.64px;\n  text-align: left;\n}\n.remove-plan {\n  border: none;\n  outline: none;\n  background: var(--white);\n}\n.edit-plan {\n  border: none;\n  outline: none;\n  background: var(--white);\n}\n.plan-actions {\n  position: absolute;\n  bottom: 26px;\n  right: 12px;\n}\n.plan-actions-edit {\n  display: none;\n}\n.plan-edit-actions {\n  position: absolute !important;\n  bottom: 39px;\n  right: 12px;\n}\n.cancel-btn {\n  width: 125px;\n  height: 44px;\n  border-radius: 40px;\n  color: #052456;\n  background-color: #fff;\n  border: 1px solid #191919;\n  font-size: 15px;\n  font-weight: 600;\n}\n.apply-btn {\n  width: 125px;\n  height: 44px;\n  border-radius: 40px;\n  background-color: #f15e22;\n  color: #fff;\n  border: none;\n  font-size: 15px;\n  font-weight: 600;\n  margin-left: 20px;\n}\n.radio-group {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 16px;\n}\n\n.optimum-plan-container {\n  background: #fff;\n  padding: 20px;\n  border-radius: 12px;\n  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.plan-selection-box {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 20px;\n  border: 1px dashed #ccc;\n  border-radius: 8px;\n}\n\n.configure-container {\n  position: static !important;\n  width: 25% !important;\n}\n\n.toggle-container {\n  display: flex;\n  flex-direction: row;\n  width: 400px;\n  gap: 60px;\n  position: relative;\n}\n\n.toggle-switch {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.toggle-input-container {\n  margin-top: 15px;\n}\n\n.configure-add-plan {\n  position: absolute;\n  left: 59vw !important;\n  bottom: 47px !important;\n}\n\n.configure-mobile-container {\n  gap: 15px;\n}\n\n.plans-error-message {\n  position: absolute;\n  bottom: -20px;\n  right: 120px;\n}\n\n.edit-error {\n  width: 75%;\n}\n\n.configure-radio-container {\n  display: flex;\n  flex-direction: row;\n  margin-top: 15px;\n}\n\n.configure-label {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.configure-input {\n  min-width: 200px;\n  height: 40px;\n  border: solid 1px #c5c5c7;\n  background: #fff;\n  border-radius: 100px;\n  padding-left: 15px;\n  color: #000;\n}\n\n.configure-imei-input {\n  margin-top: 15px;\n  color: #000;\n}\n\n.configure-radio-btn {\n  margin-top: 10px;\n  margin-right: 10px;\n}\n\n.find-imei {\n  text-decoration: underline;\n  cursor: pointer;\n  color: #757575;\n  padding: 10px 0 0 15px;\n}\n\n.find-imei-menu {\n  position: absolute;\n  width: 250px;\n  background-color: #fff;\n  padding: 15px;\n  border: 1px #bdbdbd solid;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  z-index: 2;\n}\n\n.find-imei-menu-items {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  /* justify-content: left; */\n}\n\n.find-imei-content {\n  font-size: 14px;\n  font-weight: 400 !important;\n  align-content: center;\n}\n.find-imei-info {\n  font-style: italic;\n  font-size: 13px !important;\n  color: #757575;\n}\n.check-compatibility {\n  position: absolute;\n  width: 260px;\n  left: -20px;\n  top: 28px;\n}\n.error-message {\n  color: red;\n  font-size: 12px;\n}\n.radio-container-label {\n  min-width: 125px;\n}\n.check-compatibility-contianer {\n  position: relative;\n}\n.imei-container {\n  position: relative;\n}\n/* Hide arrows for Chrome, Safari, Edge, and Opera */\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Hide arrows for Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n@media screen and (max-width: 991px) {\n  .optimum-plan .fields {\n    /* margin-left: 7%;\n    margin-right: 7%; */\n    width: 80%;\n  }\n}\n\n@media screen and (max-width: 767px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
